// Formats a value for safe use inside a Markdown table cell by
// stringifying non-strings and escaping special characters.
export function formatMarkdownTableCell(val: unknown): string {
    if (val === null || val === undefined) return '';

    let str: string;
    if (typeof val === 'string') {
        str = val;
    } else if (
        typeof val === 'number' ||
        typeof val === 'boolean' ||
        typeof val === 'bigint'
    ) {
        str = String(val);
    } else {
        // Objects/arrays: stringify
        str = JSON.stringify(val);
    }

    // Escape Markdown table pipe and normalize newlines
    return str.replace(/\|/g, '\\|').replace(/\r?\n/g, ' ');
}
